export interface ShopMovie {
  id: string;
  title: string;
}
